import React from "react";
import { Route } from "react-router";
import { ApmRoutes } from "@elastic/apm-rum-react";
import Home from "../pages/Home";

const Routes = () => {
    return (
        <ApmRoutes>
            <Route exact path='/*' element={< Home />} />
        </ApmRoutes>
    );
};

export default Routes;
